import { AxiosResponse } from 'axios';

export type FetchFunction = () => Promise<AxiosResponse<Blob>>;

export const downloadFile = async (fetchFunction: FetchFunction, defaultFileName: string) => {
  try {
    const response = await fetchFunction();

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    let fileName = defaultFileName;
    const contentDisposition = response.headers['content-disposition'];
    console.log(response.headers);

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="([^"]+)"/) || contentDisposition.match(/filename=([^;]+)/);

      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1].trim();
      }
    }

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};
